import React from 'react';
import styles from './SilentPicker.module.scss';
import { PickerItem } from './types';

interface PickerTriggerProps {
  pickerId: string;
  listboxId: string;
  isOpen: boolean;
  isQuiet: boolean;
  isDisabled: boolean;
  selectedItem?: PickerItem;
  placeholder: string;
  label?: string;
  ariaLabel?: string;
  triggerRef: React.RefObject<HTMLButtonElement>;
  onToggle: () => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
}

export function PickerTrigger({
  pickerId,
  listboxId,
  isOpen,
  isQuiet,
  isDisabled,
  selectedItem,
  placeholder,
  label,
  ariaLabel,
  triggerRef,
  onToggle,
  onKeyDown
}: PickerTriggerProps) {
  // Format selected item label with comment count if present and greater than 0
  const displayLabel =
    selectedItem && selectedItem.commentCount && selectedItem.commentCount > 0
      ? `${selectedItem.label} (${selectedItem.commentCount})`
      : selectedItem?.label;

  return (
    <button
      ref={triggerRef}
      id={pickerId}
      className={`${styles['spectrum-picker-trigger']} ${
        isOpen ? styles['is-open'] : ''
      } ${isQuiet ? styles['spectrum-picker-trigger--quiet'] : ''}`}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
      aria-labelledby={label ? undefined : undefined}
      aria-label={!label ? ariaLabel : undefined}
      aria-controls={isOpen ? listboxId : undefined}
      aria-describedby={selectedItem ? `${pickerId}-value` : undefined}
      disabled={isDisabled}
      onClick={onToggle}
      onKeyDown={onKeyDown}
      type="button"
    >
      <span
        id={`${pickerId}-value`}
        className={`${styles['spectrum-picker-label-text']} ${
          !selectedItem ? styles['is-placeholder'] : ''
        }`}
      >
        {selectedItem ? displayLabel : placeholder}
      </span>
      {/* // cHEVROLET down icon */}
      <span className={styles['spectrum-picker-icon']} aria-hidden="true">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="#292929"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
}
